import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Clock, User } from "lucide-react";

export function ActivityLog({ caseData }) {
    if (!caseData) return null;

    const activities = [
        { label: "Case Created", by: caseData.created_by_name, at: caseData.created_at },
        { label: "Consent Signed by Client", by: caseData.consent?.worker_name_signed, at: caseData.consent?.consented_at },
        { label: "Audio Recorded", by: caseData.recorded_by_name, at: caseData.recorded_at },
        { label: "AI Analyzed", by: caseData.analyzed_by_name, at: caseData.analyzed_at },
        { label: "Submitted", by: caseData.submitted_by_name, at: caseData.submitted_at },
    ].filter(a => a.at);

    return (
        <Card className="border-slate-200 mt-8 shadow-sm">
            <CardHeader className="pb-3 border-b border-slate-100 bg-slate-50/50">
                <CardTitle className="text-sm font-medium text-slate-500 uppercase tracking-wider flex items-center gap-2">
                    <Clock className="w-4 h-4" /> Activity History
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-4">
                <div className="space-y-3">
                    {activities.map((act, i) => (
                        <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between text-sm gap-1 py-1 border-b border-slate-50 last:border-0">
                            <span className="font-semibold text-slate-700 w-32">{act.label}</span>
                            <div className="flex items-center gap-2 text-slate-600 flex-1">
                                <User className="w-3 h-3 text-slate-400" />
                                <span>{act.by || "Unknown"}</span>
                            </div>
                            <span className="text-slate-400 text-xs font-mono bg-slate-100 px-2 py-0.5 rounded-sm">
                                {new Date(act.at).toLocaleString()}
                            </span>
                        </div>
                    ))}
                    {activities.length === 0 && <p className="text-slate-400 italic">No activity recorded.</p>}
                </div>
            </CardContent>
        </Card>
    );
}
